module.exports = __webpack_public_path__ + "img/card_bg.3452aed3.png";